var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPills(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 147.506,
    height: 149.332,
    viewBox: "0 0 147.506 149.332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2849"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 539",
    d: "M88.343 178.658H19.454a6.983 6.983 0 0 1-6.975-6.975V87.242h84.632l-.1 36.024-.782-.113a24.02 24.02 0 0 0-3.427-.25 23.7 23.7 0 0 0 0 47.392 24.027 24.027 0 0 0 3.3-.234l.66-.092.111.657a7.187 7.187 0 0 1-1.467 5.425c-1.461 1.73-3.839 2.607-7.066 2.607M13.852 88.615v83.068a5.609 5.609 0 0 0 5.6 5.6h68.891c2.8 0 4.818-.71 6.008-2.109a5.62 5.62 0 0 0 1.215-3.665 25.068 25.068 0 1 1 .079-49.818l.09-33.078z",
    transform: "translate(2.231 -38.326)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 540",
    d: "M86.84 37.011H9.207A9.217 9.217 0 0 1 0 27.805V9.207A9.217 9.217 0 0 1 9.207 0H86.84a9.217 9.217 0 0 1 9.206 9.207v18.6a9.216 9.216 0 0 1-9.206 9.206M9.207 1.373a7.843 7.843 0 0 0-7.834 7.834v18.6a7.843 7.843 0 0 0 7.834 7.833H86.84a7.842 7.842 0 0 0 7.833-7.833v-18.6a7.842 7.842 0 0 0-7.833-7.834z",
    style: {
      fill: "#8dfffb"
    },
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 541",
    d: "M33.684 203.2H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -100.488)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 542",
    d: "M33.684 177.933H13.18a.686.686 0 0 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -86.778)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 543",
    d: "M33.684 228.476H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -114.196)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 544",
    d: "M33.684 253.748H13.18a.686.686 0 0 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -127.906)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 545",
    d: "M33.684 152.661H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -73.069)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 546",
    d: "M33.684 127.1H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 1 1 0 1.373",
    transform: "translate(2.222 -59.205)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 547",
    d: "m152.053 208.565-.513-.4a19.8 19.8 0 0 1-8.077-16.349c.068-8.275 3.982-14.623 11.318-18.355 6.645-3.381 13.49-3.046 20.345 1l.576.339zm11.9-36.172a18.837 18.837 0 0 0-8.615 2.164c-7 3.56-10.579 9.369-10.644 17.265a18.513 18.513 0 0 0 7.1 14.957l22.123-31.6a20.346 20.346 0 0 0-9.963-2.79",
    transform: "translate(-68.823 -83.842)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 548",
    d: "M176.878 218.437a19.191 19.191 0 0 1-10.895-3.334l-.513-.353 23.381-33.392.491.285c7.669 4.461 10.53 16.25 6.123 25.229l-.065.128-.111.087a2385.427 2385.427 0 0 0-6.13 4.817l-.153.121a11.714 11.714 0 0 0-.976.831 7.42 7.42 0 0 0-1.91 3.141l-.078.26-.245.118a20.484 20.484 0 0 1-8.922 2.061m-9.675-4.008a18.59 18.59 0 0 0 17.821.949 8.691 8.691 0 0 1 2.142-3.4 12.877 12.877 0 0 1 1.077-.92l.153-.121c1.962-1.549 3.927-3.091 6.022-4.733 3.883-8.074 1.4-18.911-5.214-23.195z",
    transform: "translate(-80.762 -89.382)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 549",
    d: "M215.393 253.936a8.277 8.277 0 0 1-6.745-3.681 8.065 8.065 0 0 1-1.036-6.87 8.663 8.663 0 0 1 2.226-3.666 12.861 12.861 0 0 1 1.077-.92l.153-.121c2-1.576 4-3.146 6.135-4.821.357-.285.725-.573 1.1-.864l.632-.494 10.208 12.9-.507.381c-1.007.754-2 1.538-2.967 2.3a69.219 69.219 0 0 1-6.782 4.907 6.7 6.7 0 0 1-3.489.951m3.33-19.707q-.382.3-.756.6c-2.14 1.678-4.139 3.247-6.134 4.82l-.153.121a11.791 11.791 0 0 0-.975.831 7.426 7.426 0 0 0-1.911 3.141 6.837 6.837 0 0 0 .876 5.823c2 2.954 5.845 4.016 8.571 2.366a68.325 68.325 0 0 0 6.66-4.823c.808-.635 1.64-1.288 2.484-1.931z",
    transform: "translate(-103.434 -117.124)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 550",
    d: "m245.425 233.63-10.209-12.9.507-.38c1-.753 1.995-1.533 2.955-2.288a68.708 68.708 0 0 1 6.8-4.915c3.276-1.987 7.865-.762 10.231 2.728a8.19 8.19 0 0 1-1.188 10.535 13.254 13.254 0 0 1-1.128.96l-.106.083c-1.821 1.436-3.644 2.869-5.572 4.385zm-8.455-12.677 8.66 10.945 1.316-1.034c1.928-1.515 3.75-2.947 5.571-4.383l.107-.084a12.083 12.083 0 0 0 1.025-.868 6.97 6.97 0 0 0 1.032-8.962c-2-2.954-5.845-4.016-8.568-2.365a67.9 67.9 0 0 0-6.673 4.831c-.8.632-1.632 1.283-2.471 1.922",
    transform: "translate(-118.597 -106.108)",
    style: {
      fill: "#8dfffb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2850"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 539",
    d: "M88.343 178.658H19.454a6.983 6.983 0 0 1-6.975-6.975V87.242h84.632l-.1 36.024-.782-.113a24.02 24.02 0 0 0-3.427-.25 23.7 23.7 0 0 0 0 47.392 24.027 24.027 0 0 0 3.3-.234l.66-.092.111.657a7.187 7.187 0 0 1-1.467 5.425c-1.461 1.73-3.839 2.607-7.066 2.607M13.852 88.615v83.068a5.609 5.609 0 0 0 5.6 5.6h68.891c2.8 0 4.818-.71 6.008-2.109a5.62 5.62 0 0 0 1.215-3.665 25.068 25.068 0 1 1 .079-49.818l.09-33.078z",
    transform: "translate(2.231 -38.326)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 540",
    d: "M86.84 37.011H9.207A9.217 9.217 0 0 1 0 27.805V9.207A9.217 9.217 0 0 1 9.207 0H86.84a9.217 9.217 0 0 1 9.206 9.207v18.6a9.216 9.216 0 0 1-9.206 9.206M9.207 1.373a7.843 7.843 0 0 0-7.834 7.834v18.6a7.843 7.843 0 0 0 7.834 7.833H86.84a7.842 7.842 0 0 0 7.833-7.833v-18.6a7.842 7.842 0 0 0-7.833-7.834z",
    style: {
      fill: "#8dfffb"
    },
    transform: "translate(9 9)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 541",
    d: "M33.684 203.2H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -100.488)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 542",
    d: "M33.684 177.933H13.18a.686.686 0 0 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -86.778)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 543",
    d: "M33.684 228.476H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -114.196)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 544",
    d: "M33.684 253.748H13.18a.686.686 0 0 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -127.906)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 545",
    d: "M33.684 152.661H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 0 1 0 1.373",
    transform: "translate(2.222 -73.069)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 546",
    d: "M33.684 127.1H13.18a.686.686 0 1 1 0-1.373h20.5a.686.686 0 1 1 0 1.373",
    transform: "translate(2.222 -59.205)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 547",
    d: "m152.053 208.565-.513-.4a19.8 19.8 0 0 1-8.077-16.349c.068-8.275 3.982-14.623 11.318-18.355 6.645-3.381 13.49-3.046 20.345 1l.576.339zm11.9-36.172a18.837 18.837 0 0 0-8.615 2.164c-7 3.56-10.579 9.369-10.644 17.265a18.513 18.513 0 0 0 7.1 14.957l22.123-31.6a20.346 20.346 0 0 0-9.963-2.79",
    transform: "translate(-68.823 -83.842)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 548",
    d: "M176.878 218.437a19.191 19.191 0 0 1-10.895-3.334l-.513-.353 23.381-33.392.491.285c7.669 4.461 10.53 16.25 6.123 25.229l-.065.128-.111.087a2385.427 2385.427 0 0 0-6.13 4.817l-.153.121a11.714 11.714 0 0 0-.976.831 7.42 7.42 0 0 0-1.91 3.141l-.078.26-.245.118a20.484 20.484 0 0 1-8.922 2.061m-9.675-4.008a18.59 18.59 0 0 0 17.821.949 8.691 8.691 0 0 1 2.142-3.4 12.877 12.877 0 0 1 1.077-.92l.153-.121c1.962-1.549 3.927-3.091 6.022-4.733 3.883-8.074 1.4-18.911-5.214-23.195z",
    transform: "translate(-80.762 -89.382)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 549",
    d: "M215.393 253.936a8.277 8.277 0 0 1-6.745-3.681 8.065 8.065 0 0 1-1.036-6.87 8.663 8.663 0 0 1 2.226-3.666 12.861 12.861 0 0 1 1.077-.92l.153-.121c2-1.576 4-3.146 6.135-4.821.357-.285.725-.573 1.1-.864l.632-.494 10.208 12.9-.507.381c-1.007.754-2 1.538-2.967 2.3a69.219 69.219 0 0 1-6.782 4.907 6.7 6.7 0 0 1-3.489.951m3.33-19.707q-.382.3-.756.6c-2.14 1.678-4.139 3.247-6.134 4.82l-.153.121a11.791 11.791 0 0 0-.975.831 7.426 7.426 0 0 0-1.911 3.141 6.837 6.837 0 0 0 .876 5.823c2 2.954 5.845 4.016 8.571 2.366a68.325 68.325 0 0 0 6.66-4.823c.808-.635 1.64-1.288 2.484-1.931z",
    transform: "translate(-103.434 -117.124)",
    style: {
      fill: "#8dfffb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 550",
    d: "m245.425 233.63-10.209-12.9.507-.38c1-.753 1.995-1.533 2.955-2.288a68.708 68.708 0 0 1 6.8-4.915c3.276-1.987 7.865-.762 10.231 2.728a8.19 8.19 0 0 1-1.188 10.535 13.254 13.254 0 0 1-1.128.96l-.106.083c-1.821 1.436-3.644 2.869-5.572 4.385zm-8.455-12.677 8.66 10.945 1.316-1.034c1.928-1.515 3.75-2.947 5.571-4.383l.107-.084a12.083 12.083 0 0 0 1.025-.868 6.97 6.97 0 0 0 1.032-8.962c-2-2.954-5.845-4.016-8.568-2.365a67.9 67.9 0 0 0-6.673 4.831c-.8.632-1.632 1.283-2.471 1.922",
    transform: "translate(-118.597 -106.108)",
    style: {
      fill: "#8dfffb"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPills);
export default __webpack_public_path__ + "static/media/pills.9e322e1e020ed9339cf4c0fb4790ad92.svg";
export { ForwardRef as ReactComponent };